import { useEffect, useState } from 'react'

import { useCollectionFilterQueryParamsContext } from '../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { NextModal } from '../../../../../../../components/modals/NextModal'
import {
  modalAnimationDuration,
  standardModalBodyOpenClassName,
  standardModalPortalClassName,
} from '../../../../../../styles/constants'
import { useCollectionFiltersContext } from '../containers/CollectionFiltersContext'
import { FilterModalService } from '../containers/FilterModalService'

import { FilterModalContent } from './FilterModalContent'
import { HiddenCrawlableFilterModalContent, deriveModalStyles } from './styles'

export const FilterModal = () => {
  const { closeFilterModal, shouldDisplayFilterModal } = FilterModalService.useContainer()
  const { clearAllFilters, selectedFilters, totalNumberOfSelectedFilterValues } =
    useCollectionFilterQueryParamsContext()
  const { filters } = useCollectionFiltersContext()

  const [isModalDirty, setIsModalDirty] = useState<boolean>(false)

  useEffect(() => {
    setIsModalDirty(true)
  }, [totalNumberOfSelectedFilterValues])

  const filterModalContentProps = {
    clearAllFilters,
    closeFilterModal,
    filters,
    isModalDirty,
    selectedFilters,
    totalNumberOfSelectedFilterValues,
  }

  /**
   * Note: When FilterModal is collapsed we still want to render its content (hidden) to
   * make it crawlable on page load.
   */
  if (!shouldDisplayFilterModal) {
    return (
      <HiddenCrawlableFilterModalContent>
        <FilterModalContent {...filterModalContentProps} />
      </HiddenCrawlableFilterModalContent>
    )
  }

  return (
    <NextModal
      bodyOpenClassName={standardModalBodyOpenClassName}
      closeTimeoutMS={modalAnimationDuration}
      isOpen={shouldDisplayFilterModal}
      onRequestClose={closeFilterModal}
      onAfterOpen={() => setIsModalDirty(false)}
      portalClassName={standardModalPortalClassName}
      style={deriveModalStyles()}
    >
      <FilterModalContent {...filterModalContentProps} />
    </NextModal>
  )
}
